import { Link } from 'react-router-dom';

export default function VolumeIdCell({ id }: { id: string }) {
  return (
    <Link to={`/fleet-manager/${id}`}>
      <span className="text-[#2151F5] cursor-pointer">{id}</span>
    </Link>
  );
}
